import { render, staticRenderFns } from "./UserBox.vue?vue&type=template&id=3ea98679"
import script from "./UserBox.vue?vue&type=script&lang=js"
export * from "./UserBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports